import { SleepMonitoringState } from '@shared/redux/state/sleepMonitoring';

export const initSleepMonitoringState: SleepMonitoringState = {
  reportGeneratorPopupOpen: false,
};
